export const formatToCameraUTC = (localDate, offset) => {
  const y = localDate.getFullYear();
  const m = localDate.getMonth();
  const d = localDate.getDate();
  const h = localDate.getHours();
  const min = localDate.getMinutes();
  const s = localDate.getSeconds();
  return new Date(Date.UTC(y, m, d, h - 3 - offset, min, s)).toISOString();
};

export const formatDuration = (seconds) => {
  if (!seconds || seconds < 0) return "00:00:00";
  const h = Math.floor(seconds / 3600).toString().padStart(2, "0");
  const m = Math.floor((seconds % 3600) / 60).toString().padStart(2, "0");
  const s = Math.floor(seconds % 60).toString().padStart(2, "0");
  return `${h}:${m}:${s}`;
};

export const distToSegmentSquared = (p, v, w) => {
  const l2 = (v.x - w.x) ** 2 + (v.y - w.y) ** 2;
  if (l2 === 0) return (p.x - v.x) ** 2 + (p.y - v.y) ** 2;
  let t = ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;
  t = Math.max(0, Math.min(1, t));
  return ((p.x - (v.x + t * (w.x - v.x))) ** 2 + (p.y - (v.y + t * (w.y - v.y))) ** 2);
};

export const getInsertionIndex = (newPoint, points) => {
  if (points.length < 3) return points.length;
  let minDistance = Infinity;
  let insertIndex = points.length;
  for (let i = 0; i < points.length; i++) {
    const p1 = points[i];
    const p2 = points[(i + 1) % points.length];
    const dist = distToSegmentSquared(newPoint, p1, p2);
    if (dist < minDistance) {
      minDistance = dist;
      insertIndex = i + 1;
    }
  }
  return insertIndex;
};

export const transformTimelineForType = (timeline, type) => {
  if (!timeline) return [];
  return timeline.map((segment) => {
    let class_id = -1;
    let count = 0;
    if (type === "chair") {
      count = segment.chair_people_count || 0;
      class_id = count > 0 ? -31 : -30;
    } else if (type === "phone") {
      count = segment.phone_people_count || 0;
      class_id = count > 0 ? -41 : -40;
    } else if (type === "machine") {
      count = segment.machine_working_count || 0;
      class_id = count > 0 ? -61 : -60;
    }
    if (segment.class_id === -1 || segment.class_id === -20) {
      class_id = -1;
      count = 0;
    }
    return { ...segment, class_id: class_id, people_count: count };
  });
};

export const generateGradientMetaMap = (baseId, idleId, colors, labelBase, idleLabel) => {
  const meta = {};
  meta[String(idleId)] = { label: idleLabel, color: "#6c757d" };
  for (let i = 1; i <= 10; i++) {
    const id = baseId - i;
    const color = colors[i - 1] || colors[colors.length - 1];
    meta[String(id)] = { label: `${labelBase} (${i} ед.)`, color: color };
  }
  meta[String(baseId - 11)] = { label: `${labelBase} (10+ ед.)`, color: colors[10] || "#000000" };
  meta["default"] = { label: "Unknown", color: "#ccc" };
  return meta;
};

export const GREEN_GRADIENT = ["#a5d6a7","#81c784","#66bb6a","#4caf50","#43a047","#388e3c","#2e7d32","#1b5e20","#0d3610","#031f05","#000000"];
export const BLUE_GRADIENT = ["#90caf9","#64b5f6","#42a5f5","#2196f3","#1e88e5","#1976d2","#1565c0","#0d47a1","#08327d","#041f52","#000000"];
export const ORANGE_GRADIENT = ["#ffcc80","#ffb74d","#ffa726","#ff9800","#fb8c00","#f57c00","#ef6c00","#e65100","#bf360c","#8a2708","#000000"];
export const PURPLE_GRADIENT = ["#e1bee7","#ce93d8","#ba68c8","#ab47bc","#9c27b0","#8e24aa","#7b1fa2","#6a1b9a","#4a148c","#38006b","#000000"];
export const YELLOW_GRADIENT = ["#fff59d","#ffe082","#ffb300","#ff8f00","#f57f17","#e65100","#bf360c","#8a2708","#5d1602","#380900","#000000"];